import styled, { css, keyframes } from 'styled-components';
import { BLACK_60 } from '@gr-monorepo/common/public/ui/constants/colors';
import { SecondaryButton } from '@gr-monorepo/common/public/ui/Buttons';

const animation = keyframes`
    0% {
        box-shadow: 0 0 0 0 var(--mint-100);
        opacity: 0.45;
    }
    40% {
        opacity: 0.45;
    }
    100% {
        box-shadow: 0 0 0 9px var(--mint-100);
        opacity: 0;
    }
`;

export const CircleButton = styled.div<{ pulse?: boolean; width?: string }>`
  height: 48px;
  width: ${(props) => props.width || '48px'};
  background: var(--mint-100);
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > * {
    z-index: 1000;
  }
  ${(props) =>
    props.pulse &&
    css`
      &:after {
        content: '';
        background-color: inherit;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        z-index: 0;
        animation: ${animation} infinite 2.6s 0s linear;
        animation-delay: 1.3s;
      }
      &:before {
        content: '';
        background-color: inherit;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        z-index: 0;
        animation: ${animation} infinite 2.6s 0s linear;
        animation-delay: 0s;
      }
    `}
`;

export const FeedbackModalContent = styled.div<{ $isSuccess?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 640px;
  max-width: calc(100vw - 96px);
  height: ${({ $isSuccess }) => ($isSuccess ? '600px' : 'auto')};
  max-height: 600px;
  padding: 48px 40px 32px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FeedbackModalTitle = styled.h2`
  margin: 0 0 24px;
  padding: 0 32px 0 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: var(--font-color);
`;

export const FeedbackFormScroll = styled.div<{ $isSuccess?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow: ${({ $isSuccess }) => ($isSuccess ? 'hidden' : 'auto')};
  box-sizing: border-box;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FieldFlexRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const HintText = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: ${BLACK_60};
`;

export const PrivacyText = styled(HintText)`
  text-align: center;
`;

export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  > * {
    flex: 0 0 auto;
  }
`;

export const PolicyLink = styled.a`
  color: var(--primary-base);
  text-decoration: underline;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: var(--primary-base);
    text-decoration: underline;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 16px;
`;

export const FeedbackButtonText = styled.p`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  margin: 0;
`;

export const AttachButton = styled(SecondaryButton)`
  svg {
    display: block;
    flex-shrink: 0;
    width: 20px;
    height: 20px;

    path {
      fill: currentColor;
    }
  }
`;